module.exports = function _pipeP(f, g) {
  return function() {
    var ctx = this;
    return f.apply(ctx, arguments).then(function(x) {
      return g.call(ctx, x);
    });
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_pipeP.js
// module id = 499
// module chunks = 0